import { render, staticRenderFns } from "./Logros.vue?vue&type=template&id=3003bd4d&"
import script from "./Logros.vue?vue&type=script&lang=js&"
export * from "./Logros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports